import React from "react";
import { TextInput } from "react-admin";
import Grid from "@material-ui/core/Grid";
import { Card, CardContent, Typography, Tooltip } from "@material-ui/core";
import {
    validateRequired,
    validateNumericRequired,
} from "../../utils/Validations";

const validateInteger = (value) => {
    if (value === null || value === undefined || value === "") return undefined;
    return Number.isInteger(Number(value)) && Number(value) >= 0
        ? undefined
        : "The Value should be a whole number";
};

const validateIntegerRequired = [validateRequired, validateInteger];

// Empty input is sent as null, anything else as an integer
const parseInteger = (value) => (value === "" ? null : Number(value));

export const ShippingConfigCard = ({ classes }) => (
    <Card className={classes.customConfigCard}>
        <CardContent>
            <Typography variant="h6" style={{ marginBottom: "16px" }}>
                Shipping Configuration
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <TextInput
                        type="number"
                        source="buffer_shipping_days"
                        label="Buffer Shipping Days"
                        validate={validateNumericRequired}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Tooltip
                        title="If set to 0, Buffer Shipping Days will be applied by default for rush"
                        arrow
                        placement="top"
                    >
                        <div>
                            <TextInput
                                type="number"
                                source="rush_buffer_shipping_days"
                                label="Rush Buffer Shipping Days"
                                validate={validateNumericRequired}
                                fullWidth
                            />
                        </div>
                    </Tooltip>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextInput
                        type="number"
                        source="gemstone_buffer_shipping_days"
                        label="Gemstone Buffer Shipping Days"
                        validate={validateIntegerRequired}
                        parse={parseInteger}
                        inputProps={{ min: 0, step: 1 }}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Tooltip
                        title="If set to 0, Gemstone Buffer Shipping Days will be applied by default for rush"
                        arrow
                        placement="top"
                    >
                        <div>
                            <TextInput
                                type="number"
                                source="gemstone_rush_buffer_shipping_days"
                                label="Gemstone Rush Buffer Shipping Days"
                                validate={validateIntegerRequired}
                                parse={parseInteger}
                                inputProps={{ min: 0, step: 1 }}
                                fullWidth
                            />
                        </div>
                    </Tooltip>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextInput
                        type="number"
                        source="rush_markup"
                        label="Rush Markup"
                        validate={validateNumericRequired}
                        fullWidth
                    />
                </Grid>
            </Grid>
        </CardContent>
    </Card>
);
